import StatsPage from './StatsPage';

export default StatsPage;
